import { combine, withCallback, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { withTableController } from 'shared/hooks'

import DeleteButtonComponent from './component'

export const DeleteBankAccount = combine(
  withTableController({ id: 'member-bank-account-table' }),
  withContext(
    'adminMemberService',
    ServicesContext,
    ({ adminMemberService }) => adminMemberService
  ),
  withCallback(
    'onDeleteBeneficiariesBankAccountByIban',
    ({ adminMemberService, table }, { value }) =>
      async () => {
        await adminMemberService.removeMemberBankAccount(
          value.memberId,
          value.iban
        )
        table.refresh()
      },
    ['value']
  )
)(DeleteButtonComponent)
